import React, { Component } from 'react';
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Panel,
  Checkbox,
  Row
} from "react-bootstrap";

import {educationLevel, statusTypes} from "../config/constants";
import FormSectionStatus from "./FormSectionStatus";

class OtherInfo extends Component {
  constructor(props){
    super(props);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleChangeDependents = this.handleChangeDependents.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleToggle(key) {
    if(this.props.readOnly)
      return;
    let updates = {};
    updates[key] = !this.props[key];
    this.props.onChange(updates);
  }

  handleChangeDependents(e) {
    if(this.props.readOnly)
      return;
    const updates = { dependents: e.target.value };
    this.props.onChange(updates);
  }

  handleChange(e) {
    if(this.props.readOnly)
      return;
    const updates = {};
    updates[e.target.name] = e.target.value;
    this.props.onChange(updates);
  }

  render() {
    const {
      sjdcEops,
      otherEops,
      sjdcDsps,
      motherEdLevel,
      fatherEdLevel,
      motherLanguage,
      fatherLanguage,
      fosterYouth,
      veteran,
      headOfHousehold,
      ab540,
      cashAid,
      calworks,
      dependents,
      validationStatus,
      readOnly
    } = this.props;

    const getEducationLevelOptions = () => {
      return educationLevel.map((level, index) => {
        return (
          <option value={level.value} key={level.value}>{level.text}</option>
        )}
      );
    };

    return (
      <Panel bsStyle={validationStatus.section.status}>
        <Panel.Heading>Other Information</Panel.Heading>
        <Panel.Body>
          <h4>Check all that apply</h4>
          <Row>
            <Col md={6}>
              <Checkbox
                onChange={() => this.handleToggle('sjdcEops')}
                checked={sjdcEops}
              >
                I have participated in EOPS at SJDC
              </Checkbox>
              <Checkbox
                onChange={() => this.handleToggle('otherEops')}
                checked={otherEops}
              >
                I have participated in EOPS at another college
              </Checkbox>
              <Checkbox
                onChange={() => this.handleToggle('sjdcDsps')}
                checked={sjdcDsps}
              >
                I am currently enrolled in SJDC's Disability Support Programs and Services (DSPS)
              </Checkbox>
              <Checkbox
                onChange={() => this.handleToggle('fosterYouth')}
                checked={fosterYouth}
              >
                I am a recently emancipated foster youth (age 18-24)
              </Checkbox>
              <Checkbox
                onChange={() => this.handleToggle('ab540')}
                checked={ab540}
              >
                I am an AB540 student
              </Checkbox>
            </Col>
            <Col md={6}>
              <Checkbox
                onChange={() => this.handleToggle('veteran')}
                checked={veteran}
              >
                I am a veteran
              </Checkbox>
              <Checkbox
                onChange={() => this.handleToggle('headOfHousehold')}
                checked={headOfHousehold}
              >
                I am a single parent/head of household
              </Checkbox>
              <Checkbox
                onChange={() => this.handleToggle('cashAid')}
                checked={cashAid}
              >
                I am receiving cash aid/TANF
              </Checkbox>
              <Checkbox
                onChange={() => this.handleToggle('calworks')}
                checked={calworks}
              >
                I am receiving CalWORKs
              </Checkbox>
              <FormGroup
                controlId='dependents'>
                <ControlLabel>
                  Number of dependent children under 14 years of age
                </ControlLabel>
                <FormControl
                  componentClass="input"
                  type="number"
                  value={dependents}
                  onChange={this.handleChangeDependents}
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup controlId='mother-ed-level'
                validationState={validationStatus.motherEdLevel}>
                <ControlLabel>Mother's Highest Education Level</ControlLabel>
                <FormControl componentClass="select"
                             name="motherEdLevel"
                             value={motherEdLevel}
                             onChange={this.handleChange}>
                  <option value="">Select One</option>
                  {getEducationLevelOptions()}
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup controlId='mother-language'
                validationState={validationStatus.motherLanguage}>
                <ControlLabel>
                  Mother's First Language
                </ControlLabel>
                <FormControl
                  componentClass="input"
                  type="text"
                  name="motherLanguage"
                  value={motherLanguage}
                  placeholder="Enter N/A if unknown"
                  onChange={this.handleChange}
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup controlId='father-ed-level'
                validationState={validationStatus.fatherEdLevel}>
                <ControlLabel>Father's Highest Education Level</ControlLabel>
                <FormControl componentClass="select"
                             name="fatherEdLevel"
                             value={fatherEdLevel}
                             onChange={this.handleChange}>
                  <option value="">Select One</option>
                  {getEducationLevelOptions()}
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup controlId='father-language'
                validationState={validationStatus.fatherLanguage}>
                <ControlLabel>Father's First Language</ControlLabel>
                <FormControl
                  componentClass="input"
                  type="text"
                  name="fatherLanguage"
                  value={fatherLanguage}
                  placeholder="Enter N/A if unknown"
                  onChange={this.handleChange}
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
          </Row>
          {!readOnly && validationStatus.section.status !== statusTypes.SUCCESS &&
          <FormSectionStatus {...validationStatus.section}/>
          }
        </Panel.Body>
      </Panel>
    )
  }
}

export default OtherInfo